import { render } from "./SinistroAprovacaoDetalheView.vue?vue&type=template&id=1ace5812&scoped=true"
import script from "./SinistroAprovacaoDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroAprovacaoDetalheView.vue?vue&type=script&lang=js"

import "./SinistroAprovacaoDetalheView.vue?vue&type=style&index=0&id=1ace5812&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ace5812"]])

export default __exports__